<mat-form-field class="months-selector" appearance="outline">
  <mat-label>{{ 'Mois' }}</mat-label>
  <mat-select multiple [(ngModel)]="selectedMonths" [disabled]="!availableMonths || availableMonths.length === 0">
    @for (month of months; track $index) {
    <mat-option [value]="month">
      {{ month }}
    </mat-option>
    }
  </mat-select>
</mat-form-field>